import { useState, useEffect } from 'preact/hooks';
import { api, type CoinMarket } from '../services/api.js';
import { REFRESH_INTERVAL } from '../utils/constants.js';

/**
 * Fetch live market rates for the header ticker tape.
 * Refreshes on the global cadence; silent on error (ticker just stays empty).
 */
export function useRates(): CoinMarket[] {
  const [rates, setRates] = useState<CoinMarket[]>([]);

  useEffect(() => {
    const controller = new AbortController();
    const load = () => {
      api.getRates(undefined, controller.signal)
        .then(setRates)
        .catch(() => { /* keep last good data */ });
    };
    load();
    const id = setInterval(load, REFRESH_INTERVAL);
    return () => { controller.abort(); clearInterval(id); };
  }, []);

  return rates;
}
